import type { AuthLicense } from '@robovision/rvai-auth'


export enum LicenseState {
  INVALID,
  EXPIRED,
  EXPIRING,
  VALID,
}

export enum LicenseInfoType {
  LICENSE_KEY,
  MACHINE_REFERENCE,
}

interface LicenseParams {
  active: boolean
  expiresAt: Date
  licenseKey?: string
  machineReference?: string
}

export class License {
  public readonly active: boolean
  public readonly expiresAt: Date
  public readonly licenseKey?: string
  public readonly machineReference?: string

  public constructor (params: LicenseParams) {
    this.active = params.active
    this.expiresAt = params.expiresAt
    this.licenseKey = params.licenseKey
    this.machineReference = params.machineReference

    Object.freeze(this)
  }

  public static fromResponse (data: AuthLicense) {
    return new License({
      active: data.active,
      expiresAt: new Date(data.expires_at),
      licenseKey: data.license_key,
      machineReference: data.metadata.machine_reference,
    })
  }
}
